import { render, staticRenderFns } from "./SupportCollectomate.vue?vue&type=template&id=30a8696d&scoped=true&lang=pug&"
import script from "./SupportCollectomate.vue?vue&type=script&lang=js&"
export * from "./SupportCollectomate.vue?vue&type=script&lang=js&"
import style0 from "./SupportCollectomate.vue?vue&type=style&index=0&id=30a8696d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a8696d",
  null
  
)

export default component.exports